import React, { useState } from "react";
import { Label, SpinButton } from "../components/utils/Form.jsx";
import {Fotter, Header, Section} from "../components/layout";
import { BaseUrl } from "../server.js";
import Heading from "../components/Heading";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useStateContext } from "../context/ContextProvider.js";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useLocation } from "react-router-dom";
function ResetPassword() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const location = useLocation();
  const { userId, email } = location.state 

  const [password ,setPassword]=useState("")
  const { currentDir } = useStateContext();
  const [isLoadingCreate, setIsLoadingCreate] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if(password != confirmPassword){
      toast.warning(<span className="font-kufi text-sm text-tcolor-4 dark:text-tcolor-1">كلمة المرور  غير متطابقة </span>)
    }else{try{
    setIsLoadingCreate(true);
  
    const config = { headers: { "Content-Type": "application/json"}};
 const {data}=   await axios.post(`${BaseUrl}/user/reset-password`, {email,password})
      
        if (data.success){
    
        setIsLoadingCreate(false);       
         toast.success(<span className="font-kufi dark:text-tcolor-1 text-tcolor-4 text-sm">{t("Reset Success!")}</span>);
        navigate("/Login");
        window.location.reload(true);  }  
   
   } catch (error)  {
        setIsLoadingCreate(false);
        toast.error(<span className="font-kufi dark:text-tcolor-1 text-tcolor-4 text-sm">{error.response?.data?.message}</span>);

      }}
  };

  return (<>
  <Header />
    <Section>
      <div className="container pt-10 ">
        <Heading title={t("Login your account")} />
        <form
          onSubmit={handleSubmit}
          className="w-full mx-auto bg-n-1 dark:bg-back-darksecondary backdrop-blur-xl rounded-lg shadow dark:border md:mt-0 sm:max-w-md border border-n-1/10  xl:p-10 p-5"
        >
      
          <div className="relative">
            <Label
              labelText="Password"
              value={password}
              onChange={(e)=>setPassword(e.target.value)}
              required={true}
              type={visible ? "text" : "password"}
              name="password"
            />
            {visible ? (
              <AiOutlineEye
                className={` text-color-1/80 dark:text-n-1/80  absolute ${
                  currentDir == "ltr" ? "right-2" : "left-2"
                } top-3 cursor-pointer`}
                size={25}
                onClick={() => setVisible(false)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className={`text-tcolor-6 dark:text-n-1/80 absolute ${
                  currentDir == "ltr" ? "right-2" : "left-2"
                } top-3 cursor-pointer`}
                size={25}
                onClick={() => setVisible(true)}
              />
            )}
          </div>

          <div className="relative">
            <Label
              labelText= "Password confirmation"
              value={confirmPassword}
              onChange={(e)=>setConfirmPassword(e.target.value)}
              required={true}
              type={visible ? "text" : "password"}
              name="confirmPassword"
            />
            {visible ? (
              <AiOutlineEye
                className={` text-color-1/80 dark:text-n-1/80  absolute ${
                  currentDir == "ltr" ? "right-2" : "left-2"
                } top-3 cursor-pointer`}
                size={25}
                onClick={() => setVisible(false)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className={`text-tcolor-6 dark:text-n-1/80 absolute ${
                  currentDir == "ltr" ? "right-2" : "left-2"
                } top-3 cursor-pointer`}
                size={25}
                onClick={() => setVisible(true)}
              />
            )}
          </div>

          <div className="flex flex-col items-center mx-auto">
            {" "}
            <SpinButton isLoading={isLoadingCreate}>{t("Verify")}</SpinButton>
          </div>
      
     

        </form>
      </div>
    </Section>
    <Fotter />
    </>
  );
}

export default ResetPassword;
